import React from 'react';
import styled from 'styled-components';
import { Button, Space, Typography } from 'antd';
import { PlusOutlined, ImportOutlined, ExportOutlined, BarChartOutlined, ThunderboltFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

const TemplatePageHeader = ({
  onCreateNew,
  onImport,
  onExport,
  onViewAnalytics,
}) => {
  return (
    <HeaderContainer>
      <TitleSection>
        <Space size="middle" align="center">
          <MainTitle level={4}>Template Management</MainTitle>
          <Subtitle>Manage and configure AI report templates.</Subtitle>
        </Space>
      </TitleSection>

      <ActionsSection>
        <Space size={8}>
          <PremiumButton icon={<BarChartOutlined />} onClick={onViewAnalytics} variant="ghost">Analytics</PremiumButton>
          <PremiumButton icon={<ExportOutlined />} onClick={onExport} variant="ghost">Export</PremiumButton>
          <PremiumButton icon={<ImportOutlined />} onClick={onImport} variant="ghost">Import</PremiumButton>
          <PremiumButton type="primary" icon={<PlusOutlined />} onClick={onCreateNew} variant="primary">Create Template</PremiumButton>
        </Space>
      </ActionsSection>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: white;
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f5f9;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 8px;
  background: var(--aura-navy);
  border-radius: 4px;
`;

const BadgeText = styled.span`
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1px;
  color: white;
`;

const MainTitle = styled(Title)`
  margin: 0 !important;
  font-weight: 800 !important;
  font-size: 16px !important;
  color: var(--aura-navy) !important;
`;

const Subtitle = styled(Text)`
  font-size: 12px;
  color: var(--aura-slate);
`;

const ActionsSection = styled.div`
  display: flex;
  align-items: center;
`;

const PremiumButton = styled(Button)`
  height: 32px !important;
  padding: 0 16px !important;
  border-radius: 6px !important;
  font-weight: 700 !important;
  font-size: 11px !important;
  display: flex !important;
  align-items: center !important;
  
  ${props => props.variant === 'primary' && `
    background: var(--aura-navy) !important;
    border: none !important;
    color: white !important;
    &:hover { background: #112240 !important; }
  `}

  ${props => props.variant === 'ghost' && `
    background: transparent !important;
    border: 1px solid #e2e8f0 !important;
    color: var(--aura-slate) !important;
    &:hover { border-color: var(--aura-navy) !important; color: var(--aura-navy) !important; background: #f8fafc !important; }
  `}
`;

export default TemplatePageHeader;


